// src/pages/ChangePassword.jsx
import React, { useState } from 'react';
import { changeAdminPassword } from '../api';

export default function ChangePassword({ theme, setTheme }) {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const [success, setSuccess] = useState('');
  const [showPasswords, setShowPasswords] = useState(false);

  function validate() {
    if (!oldPassword || !newPassword || !confirm) {
      return 'All fields are required.';
    }
    if (newPassword.length < 8) {
      return 'New password should be at least 8 characters.';
    }
    if (newPassword !== confirm) {
      return 'New password and confirm password do not match.';
    }
    return '';
  }

  async function submit(e) {
    e.preventDefault();
    setErr('');
    setSuccess('');

    const v = validate();
    if (v) {
      setErr(v);
      return;
    }

    setBusy(true);
    try {
      const res = await changeAdminPassword({ oldPassword, newPassword });
      setSuccess(res.message || 'Password changed successfully');
      setOldPassword('');
      setNewPassword('');
      setConfirm('');
    } catch (e) {
      setErr(e.message || 'Failed to change password');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className={`auth-wrapper ${theme === 'dark' ? 'auth-dark' : 'auth-light'}`}>
      <div className="auth-card single">
        <div className="auth-card-right">
          <div className="auth-header">
            <div>
              <h2 className="auth-title">Change Admin Password</h2>
              <p className="auth-subtitle">
                For security, please enter your current password before setting a new one.
              </p>
            </div>
            <button
              type="button"
              className="btn secondary theme-toggle"
              onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
            >
              {theme === 'dark' ? '☀ Light Mode' : '🌙 Dark Mode'}
            </button>
          </div>

          <form onSubmit={submit} className="auth-form">
            <div className="form-group">
              <label>Current Password</label>
              <input
                className="input"
                type={showPasswords ? 'text' : 'password'}
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Enter current password"
              />
            </div>

            <div className="form-group">
              <label>New Password</label>
              <input
                className="input"
                type={showPasswords ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter new password"
              />
              <small className="field-hint">
                Use at least 8 characters. Mix letters, numbers & symbols.
              </small>
            </div>

            <div className="form-group">
              <label>Confirm New Password</label>
              <input
                className="input"
                type={showPasswords ? 'text' : 'password'}
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="Re-enter new password"
              />
            </div>

            <div className="form-group-inline">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={showPasswords}
                  onChange={() => setShowPasswords((p) => !p)}
                />
                <span>Show passwords</span>
              </label>
            </div>

            {err && <div className="form-error">{err}</div>}
            {success && <div className="form-success">{success}</div>}

            <button className="btn primary full" type="submit" disabled={busy}>
              {busy ? 'Updating…' : 'Update Password'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
